import React, { Component } from 'react';
import css from '../ProjectPage/ProjectPage.module.scss';
import Header from '../ProjectPage/Header';
import ProjectItem from '../ProjectItem.js';

import ImgU1 from './assets/U1.jpg';
import ImgU2 from './assets/U2.jpg';
import ImgU3 from './assets/U3.jpg';
import ImgU4 from './assets/U4.jpg';
import ImgU5 from './assets/U5.png';
import ImgU6 from './assets/U6.png';
import ImgU7 from './assets/U7.png';
import ImgU8 from './assets/U8.jpg';
import ImgU9 from './assets/U9.jpg';
import ImgU10 from './assets/U10.jpg';
import ImgU11 from './assets/U11.jpg';
import ImgU12 from './assets/U12.jpg';
import ImgU13 from './assets/U13.png';
import ImgU14 from './assets/U14.png';
import ImgU15 from './assets/U15.png';
import ImgU16 from './assets/U16.jpg';
import ImgU17 from './assets/U17.jpg';
import ImgU18 from './assets/U18.png';

import ImgBeboTournaments from '../assets/BeboTournaments.jpg';
import ImgBeboStreaming from '../assets/BeboStreaming.jpg';

export default class Twitch extends Component {

  render () {
      return (
        <div className={css.projectPage}>
          <Header
            title='Urban Mobility App'
            year='2020'
            position='Freelance Product & Brand Designer'
          />
          <div className={css.content}>
            <img src={ImgU1} alt='Urban Mobility App' />
            <div className={css.text}>
              <p>I was approached by a stealth-mode urban mobility startup to help them design an early brand identity, design their consumer ridesharing app, and explore designs for their vehicles.</p>
              <p>The startup was developing an electric single passenger vehicle with an accompanying on-demand service, as well as the technology to convert any production car into a fully autonomous vehicle. Their service focused on customers who want an ecologically friendly, all-weather, last mile transportation option to a variety of urban locations including places of work, leisure, and living.</p>
              <p>The project started with persona development of the customers in targeted pilot cities to inform product and design decisions.</p>
            </div>
            <img src={ImgU2} alt='Persona' />
            <img src={ImgU3} alt='Persona' />
            <img src={ImgU4} alt='Persona' />
            <div className={css.text}>
              <p>Logo marque and brand explorations were conducted in parallel to vehicle design explorations. The customer needed a logo marque and brand colour that could easily be identified by a person in a passing car which helped narrow down the logo marque to a typographic style and a bright purple colour rarely seen on the road.</p>
            </div>
            <img src={ImgU5} alt='Logo Explorations' />
            <img src={ImgU6} alt='Logo' />
            <div className={css.text}>
              <p>70% of car trips in the US only have a single passenger so the client planned to utilise EV microcars which are cheap and widely available in Asia and can ride in underutilised bike lanes and other specially marked routes in pilot cities. Working with the client we targeted two designs: striped and bordered. We explored the use of several colour schemes which would aid users in vehicle identification, but with a small launch fleet we decided on a single colour design for this phase of the pilot.</p>
            </div>
            <img src={ImgU7} alt='Vehicle Explorations' />
            <img src={ImgU8} alt='Vehicle Explorations' />
            <img src={ImgU9} alt='Vehicle Angles' />
            <img src={ImgU10} alt='Vehicle Data Sheet' />
            <div className={css.text}>
              <p>In situ designs helped the client and external stakeholders envision the vehicle’s scale and branding and its ability to integrate into underutilised bike infrastructure. </p>
            </div>
            <img src={ImgU11} alt='In situ shots' />
            <img src={ImgU12} alt='In situ white sheet' />
            <div className={css.text}>
              <p>Later vehicle explorations focused on production car models that could be converted to semi or fully autonomous vehicles with a proprietary kit. Example colour combinations reflected a future fleet where the car’s colour would be identified in the mobile app to aid the rider in visually acquiring their car on a busy street.</p>
            </div>
            <img src={ImgU13} alt='Vehicle Explorations' />
            <img src={ImgU14} alt='Vehicle Explorations' />
            <div className={css.text}>
              <p>I worked with the client to wireframe a happy path for a first time user which helped identify missing user stories and edge cases. Because the product envisions users driving the vehicle, the onboarding of the product is fairly long and requires a driver’s license verification. In the wireframing process, I identified areas where the onboarding could be shortened and permissions could be requested a later time in the user’s experience. </p>
            </div>
            <img src={ImgU15} alt='Wireframes' />
            <img src={ImgU16} alt='App Screens' />
            <div className={css.text}>
              <p>After the vehicle arrives, the user’s phone is docked on the dashboard and the user goes through a safety checklist before launching guidance and heading for their destiantion. Because the phone is visible to the driver while driving, I designed the app with a dark mode for use at night.</p>
            </div>
            <img src={ImgU17} alt='Night and Day Modes' />
            <div className={css.text}>
              <p>The last phase of the project included a design of a B2B platform for corporate account holders to manage their employees accounts. </p>
            </div>
            <img src={ImgU18} alt='Business Portal' />
          </div>
          <div className={css.moreWork}>
            <header>More Projects</header>
              <ul className={css.moreWorkList}>
                <ProjectItem
                  title='Bebo Tournaments'
                  description='Esports for Everybody'
                  position='Product Designer / Booth Design'
                  img={ImgBeboTournaments}
                  link='BeboTournaments'
                />
                <ProjectItem
                  title='Bebo Streaming Software'
                  description='Next gen streaming software'
                  position='Product Designer / Apparel Design'
                  img={ImgBeboStreaming}
                  link='BeboStreaming'
                />
              </ul>
          </div>
        </div>
      )
   }
}
